/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import * as global from "../../js/global";
	import * as helper from "../../js/helper";
	import full_loading from "../components/full-loading.vue";
	const __vue_script__ ={
        components: {
            full_loading:full_loading,
        },
		name:'uploader_contact_info_widget',
        props: { 
            property_json: {
                type: String,
            },
            property_data: {
                type: Object,
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading:false,
				property: null,
                uploader:null,
                contact_no:{
                    "Phone":null,
                    "whatsapp":null
                },
			}
		},
        mounted(){
            if(this.property_json != undefined)
                this.property = JSON.parse(this.property_json);
            else
                this.property = this.property_data;
            this.load_data();
        },
		methods: {
            load_data: async function(){
                if(this.is_loading)
                    return;
                this.is_loading = true;
                let params = {
                    "property_name" : this.property.name
                };
                let res = await $.ajax({
                    url: "/api/method/maalek.api.get_uploader_info",
                    type: "GET",
                    data: params
                });
                this.uploader = res.message;
                this.is_loading = false;
                this.$forceUpdate();
            },
            send_contact_request: async function(){
                this.form_sent = true;
                let params = {
                    property_name : this.property.name
                };
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.send_contact_request",
                        type: "POST",
                        // data: params //for GET request
                        data: JSON.stringify(params) //for POST request
                    });
                    this.loading = false
                    helper.showSuccess("Contact request sent successfully",()=>{
						location.reload();
					});
                } catch (e) {
                    var exceptions = helper.showException(e);
                }
                
                this.loading = false
            },
            get_contact_no: async function(medium){
                if(medium == "Whatsapp" && this.contact_no["Whatsapp"]){
                    return this.whatsapp();
                }
                if(this.is_loading)
                    return;
                global.emitter.emit("show-full-loading");
                this.is_loading = true;
                let params = {
                    "doc" : this.property.name,
                    "medium": medium,
                    "platform": "Web"
                };
                try {
                    let res = await $.ajax({
                        url: "/api/method/maalek.api.get_property_contact_no",
                        type: "GET",
                        data: params
                    });
                    this.contact_no[medium] = res.message;
                    if(medium == "Whatsapp"){
                        this.whatsapp();
                    }
                } catch (e) {
                    var exceptions = helper.showException(e);
                }
                global.emitter.emit("hide-full-loading");
                this.is_loading = false;
                this.$forceUpdate();
            },
            whatsapp: function(){
                if(!this.contact_no["Whatsapp"]) return;
                message = helper.t(`Hello, I would like to get in touch with you regarding your advertisement about`) 
                + " *" +helper.t('{0} for '+this.property.ad_type,[this.property.property_type])+"* "
                +helper.t(`on *Malek App*.
{0}`,["https://maalek.net/property/"+this.property.name]);
                window.open(encodeURI('https://wa.me/'+this.contact_no["Whatsapp"].substring(1)+"?text="+message),"_blank");
            }
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-lg-12" },
    [
      _c("full_loading"),
      _vm._v(" "),
      _vm.uploader != null && _vm.frappe.session_user != "Guest"
        ? _c(
            "span",
            [
              _vm.uploader.owner_name
                ? [
                    _vm.uploader.allow_call
                      ? _c("a", { staticClass: "mb-1" }, [
                          _c("i", { staticClass: "fa-solid fa-user" }),
                          _vm._v(" " + _vm._s(_vm.uploader.owner_name))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _c("br")
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.uploader.allow_call
                ? _c("a", { staticClass: "mb-1" }, [
                    _c("i", { staticClass: "fa-solid fa-phone" }),
                    _vm._v(" "),
                    _vm.contact_no["Phone"]
                      ? _c("a", [
                          _vm._v(
                            "\n                    0" +
                              _vm._s(_vm.contact_no["Phone"].substring(4)) +
                              "\n                "
                          )
                        ])
                      : _c(
                          "span",
                          {
                            staticClass: "show-hand",
                            on: {
                              click: function($event) {
                                return _vm.get_contact_no("Phone")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                   " +
                                _vm._s(_vm.helper.t("View Contact No.")) +
                                "\n                "
                            )
                          ]
                        )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.uploader.allow_whatsapp
                ? [
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "mb-1 show-hand",
                        on: {
                          click: function($event) {
                            return _vm.get_contact_no("Whatsapp")
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa-brands fa-whatsapp fa-lg" }),
                        _vm._v(" "),
                        _c("a", [_vm._v(_vm._s(_vm.helper.t("Send Whatsapp")))])
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.frappe.session_user != "Guest" &&
              !_vm.uploader.allow_whatsapp &&
              !_vm.uploader.allow_call &&
              !_vm.uploader.visit_requested
                ? _c(
                    "a",
                    {
                      staticClass: "btn default-btn",
                      attrs: { role: "button" },
                      on: { click: _vm.send_contact_request }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.helper.t("Send Contact Request")) + " "
                        ),
                        _c("i", {
                          staticClass: "fa-solid fa-paper-plane fa-lg"
                        })
                      ])
                    ]
                  )
                : _vm.frappe.session_user == "Guest"
                ? _c("p", [
                    _vm._v(
                      _vm._s(_vm.helper.t("Please login to contact owner."))
                    )
                  ])
                : _vm.uploader.visit_requested &&
                  !_vm.uploader.allow_whatsapp &&
                  !_vm.uploader.allow_call
                ? _c("p", [_vm._v(_vm._s(_vm.helper.t("Contact requested.")))])
                : _vm._e()
            ],
            2
          )
        : _c("span", [
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.helper.t("Please login to see uploader's information")
                )
              )
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn default-btn",
                attrs: { href: "/account/auth" }
              },
              [_vm._v(_vm._s(_vm.helper.t("Login")))]
            )
          ])
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-635144fd_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"uploader-contact-info-widget.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/uploader-contact-info-widget.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__